import { render, staticRenderFns } from "./DataTriangulationDashboard.vue?vue&type=template&id=b0bc1394&scoped=true"
import script from "./DataTriangulationDashboard.vue?vue&type=script&lang=js"
export * from "./DataTriangulationDashboard.vue?vue&type=script&lang=js"
import style0 from "./DataTriangulationDashboard.vue?vue&type=style&index=0&id=b0bc1394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc1394",
  null
  
)

export default component.exports